import React from 'react';
import SuperAdminLayout from '../../layout/SuperAdminLayout';
const SuperadminConfigs = () => {
    return (
        <SuperAdminLayout>
            SuperadminConfigs
        </SuperAdminLayout>
    )
}

export default SuperadminConfigs;